import React from 'react'
import { useLocation } from 'react-router-dom'

import useCart from '../../data/useCart'
import useOrder from '../../data/useOrder'
import getPhoenixUrlParams from '../../lib/get-phoenix-url-params'

import { isSupportedPaymentMethodType } from '../../typings/Payment'
import {
  AvailablePaymentMethodsCartDocument,
  AvailablePaymentMethodsCartQuery,
  AvailablePaymentMethodsOrderDocument,
  AvailablePaymentMethodsOrderQuery,
} from '../../graphql'
import AvailablePaymentMethodsComponent from './AvailablePaymentMethodsComponent'

const AvailablePaymentMethods: React.FC<React.PropsWithChildren<unknown>> = () => {
  const location = useLocation()
  const { cartId, orderId } = getPhoenixUrlParams(location.search)

  const { cartData, isCartLoading } = useCart<AvailablePaymentMethodsCartQuery>(AvailablePaymentMethodsCartDocument, {
    skip: !cartId,
    nextFetchPolicy: 'standby',
  })

  const { orderData, isOrderLoading } = useOrder<AvailablePaymentMethodsOrderQuery>(
    AvailablePaymentMethodsOrderDocument,
    {
      skip: !orderId,
      nextFetchPolicy: 'standby',
    },
  )

  const data = (cartData && cartData.cart) || (orderData && orderData.order)
  const isLoading = isCartLoading || isOrderLoading

  if (!data || isLoading) {
    return null
  }

  const paymentMethods =
    (data.__typename === 'Cart' && data.paymentMethods) ||
    (data.__typename === 'Order' && data.payment && data.payment.paymentMethods) ||
    []

  const availablePaymentMethods = paymentMethods.filter(isSupportedPaymentMethodType)

  return availablePaymentMethods.length > 0 ? (
    <AvailablePaymentMethodsComponent paymentMethods={availablePaymentMethods} />
  ) : null
}

export default AvailablePaymentMethods
